import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';

import Loading from '../../components/loading';
import NotFoundError from '../../desktop/components/error-pages/not-found';

import {
  fetchPurchase,
  fetchConsumerFieldSchemas,
} from '../../actions/index';


export default function (ComposedComponent) {
  class LoadPurchase extends Component {
    constructor(props) {
      super(props);

      this.state = {
        notFound: false,
      }
    }
    componentWillMount() {
      const slug = this.props.match.params.id;
      const token = get(this.props, 'authentication.token');

      this.props.fetchPurchase(slug).then(() => {
        this.props.fetchConsumerFieldSchemas(slug, token);
      }).catch((e) => {
        this.setState({
          notFound: true,
        });
      }) ;
    }

    isLoading() {
      const { purchase, currentMembershipId } = this.props;
      const consumerFieldSchemas = get(purchase, 'consumerFieldSchemas', []);

      if (!purchase) return true;
      if (purchase.hasConsumerFieldSchemas && !consumerFieldSchemas.length) return true;
      // TODO: This is a temp fix, we need to change the order in the fetch purchase action
      // https://www.pivotaltracker.com/story/show/150245875
      if (!currentMembershipId) return true;

      return false;
    }

    render() {
      if (this.state.notFound) {
        return <NotFoundError />
      }

      if (this.isLoading()) return <Loading />;

      return <ComposedComponent {...this.props} />;
    }
  }

  const mapStateToProps = (state) => {
    const { purchases, session } = state;

    const purchase = purchases.byId[purchases.current];

    return {
      authentication: session.authentication,
      purchase,
      currentMembershipId: state.memberships.current,
    };
  };

  const mapDispatchToProps = {
    fetchPurchase,
    fetchConsumerFieldSchemas,
  };
  return connect(mapStateToProps, mapDispatchToProps)(LoadPurchase);
}



// WEBPACK FOOTER //
// ./src/components/hoc/load-purchase.js